<template>
    <Tile @go-back="goBackAction()" v-if="activePage != null">
        <template #title>
            <h1>{{ activePage.name }}</h1>
        </template>
        <template #content v-if="activePage.sections && activePage.sections.length > 0">
             <div class="row justify-center" v-if="shouldShowPrepage()">
                <div v-for="(section, index) in activePage.sections" :key="index" :class="`sm-${Math.floor(12 / activePage.sections.filter(p => p.image).length)}`">
                    <div class="prepage-section" @click="selectSection(index)">
                        <img
                            class="clickable"
                            :alt="section.title"
                            :src="section.imageContent ? `${section.imageContent}` : `${staticUrl}Images/${section.image}` + '?q=' + buildNumber"
                        />
                        <h2>{{ section.title }}</h2>
                    </div>
                </div>
             </div>
             <div v-else>
                <i v-show="svgLoading" class="icon loading" />
                <div class="subpage-section" :class="{ 'with-header': hasSectionHeader() }">
                  <div class="slide-nav slide-left">
                    <i class="icon icon-chevron-left text-xl clickable" @click="slideLeft()" />
                  </div>
                  <div class="subpage-header" v-if="hasSectionHeader()">
                        <h2>{{activePage.sections[activeSlide].title}}</h2>
                        <p class="mb-0-5">{{activePage.sections[activeSlide].description}}</p>
                        <p class="mb-0-5">{{activePage.sections[activeSlide].description2}}</p>
                        <p class="mb-0-5">{{activePage.sections[activeSlide].description3}}</p>
                  </div>
                  <template v-if="activePage.sections && activePage.sections.length > 0">
                    <InlineSvg v-if="!activePage.sections[activeSlide].svgContent"
                        :src="`${staticUrl}SVGs/${activePage.sections[activeSlide].svg}` + '?' + buildNumber" ref="svg" @loaded="onSvgLoaded"/>
                    <InlineSvg v-else :src="activePage.sections[activeSlide].svgContent" ref="svg" @loaded="onSvgLoaded"/>
                  </template>
                  <div class="slide-nav slide-right">
                    <i class="icon icon-chevron-right text-xl clickable" @click="slideRight()" />
                  </div>
                </div>
             </div>
        </template>
    </Tile>
</template>
<script>
import { getStaticUrl } from '@/helpers';
import StaticUrlService from '@/services/staticUrlService';
import axios from 'axios';
import readIsManaVersionFlag from '@/shared/manaVersionHelper';
import Tile from '@/components/base.component/Tile.vue';
import { FILE_NAMES } from '@/constants/staticFileNames';
import InlineSvg from 'vue-inline-svg';
import SvgProductRedirectService from '@/services/svgProductRedirectService';

export default {
  components: {
    Tile,
    InlineSvg
  },
  props: {
    page: {
      type: Object
    },
    pageId: {
      type: String
    }
  },
  data() {
    return {
      activeSlide: null,
      buildNumber: 0,
      activePage: null,
      svgLoading: true
    }
  },
  computed: {
    staticUrl() {
      return getStaticUrl(null, this.$route.name);
    },
  },
  async mounted() {
    await this.loadStaticFiles();
  },
  watch: {
    page(newPage) {
      this.selectPage(newPage);
    }
  },
  methods: {
    async loadStaticFiles() {
        const fullStaticUrl = await StaticUrlService.getFullStaticUrl(null, this.$route.name);
        axios
        .get(`${fullStaticUrl}${FILE_NAMES.PRODUCTSDATA}?` + Date.now())
        .then((result) => {
            this.$store.commit(
            'radios',
            result.data.filter((x) => x.isMana == readIsManaVersionFlag())
            );
        });
        axios
        .get(`${fullStaticUrl}${FILE_NAMES.ASSETSCONFIG}?` + Date.now())
        .then((result) => {
            this.buildNumber = result.data.buildNumber;
        });

        if(!this.page) {
            axios
            .get(`${fullStaticUrl}${FILE_NAMES.PAGES}?` + Date.now())
            .then((result) => {
                const newPage = result.data.find(p => p.id === this.pageId);
                this.selectPage(newPage);
                if (this.$route.query.activeSlide) {
                    this.activeSlide = parseInt(this.$route.query.activeSlide);
                }
            });
        } else {
            this.selectPage(this.page);
        }
    },
    shouldShowPrepage() {
      return this.activePage.sections.some(s => s.image) && this.activeSlide === null;
    },
    goBackAction() {
        if(this.activeSlide != null && this.activePage.sections.some(s => s.image)) {
            this.activeSlide = null;
        } else if(this.pageId) {
            this.$router.push({name: 'radio'});
        }
    },
    slideLeft() {
      this.activeSlide = this.activeSlide === 0 
        ? this.activePage.sections.length - 1 
        : this.activeSlide - 1;
    },
    slideRight() {
      this.activeSlide = this.activeSlide === this.activePage.sections.length - 1 
        ? 0 
        : this.activeSlide + 1;
    },
    selectSection(index) {
      this.activeSlide = index;
    },
    selectPage(newPage) {
        this.activePage = newPage;
        this.activeSlide = this.activePage.sections && this.activePage.sections.every(s => !s.image) ? 0 : null;
    },
    hasSectionHeader() {
        return this.activePage.sections[this.activeSlide].title || this.activePage.sections[this.activeSlide].description;
    },
    onSvgLoaded() {
        this.svgLoading = false;
        if(this.$refs.svg) {
            SvgProductRedirectService.registerRedirects(
                this.$refs.svg, 
                `page/${this.pageId}`, 
                this.activeSlide, 
                this.$router, 
                this.$store, 
                !this.pageId
            );
        }
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/assets/common.less';

.prepage-section {
    text-align: center;
    padding: @space-large;
    height: calc(100vh - 48px * 3 - @space-xl);
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    position: relative;

    img {
        max-height: 90%;
        max-width: 90%;
        width: auto;
        height: auto;
    }
}

.subpage-section {
    padding: @space-large;
    height: calc(100vh - 48px * 3 - @space-xl);
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    position: relative;

    .subpage-header {
        position: absolute;
        left: @space-3xl;
        top: 0;
        width: 33%;
    }

    &.with-header {
        svg {
            margin-left: 33%;
        }
    }

    svg {
        ::v-deep polygon {
            cursor: pointer;
            color: #00000000;
            fill: transparent;
        }
    }

    .slide-left {
        position: absolute;
        top: 48%;
        z-index: 10;
        left: 1rem;
    }

    .slide-right {
        position: absolute;
        top: 48%;
        left: calc(100% - 50px);
        z-index: 10;
    }

    .slide-nav i {
        font-size: 46px;
    }

    .slide-nav:hover i {
        font-size: 48px;
    }
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>